import {
	type CSSProperties,
	type ReactNode,
	useCallback,
	useState,
} from "react";
import { cn } from "@/lib/utils";

export function Reveal({
	children,
	className,
	delay,
}: {
	children: ReactNode;
	className?: string;
	delay?: number;
}) {
	const [inView, setInView] = useState(false);
	const ref = useCallback((node: HTMLDivElement | null) => {
		if (!node) return;
		if (typeof IntersectionObserver === "undefined") {
			setInView(true);
			return;
		}
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry?.isIntersecting) {
					setInView(true);
					observer.disconnect();
				}
			},
			{ rootMargin: "0px 0px -10% 0px", threshold: 0.12 },
		);
		observer.observe(node);
	}, []);

	const style: CSSProperties | undefined = delay
		? { transitionDelay: `${delay}ms` }
		: undefined;

	return (
		<div
			ref={ref}
			className={cn("reveal", inView && "reveal-in", className)}
			style={style}
		>
			{children}
		</div>
	);
}
